export { type UserSlide, userSlideTable } from "#user-slide-table";
